import { createSlice } from "@reduxjs/toolkit";
import { getPaymentGatewayList } from "./ThunkActions";
import { iPaymentGatewayState, REDUCER_NAME } from "./Types";

const initialState: iPaymentGatewayState = {
  isLoading: false,
  paymentGatewayList: [], 
  errorMessage: null,
};

export const paymentGatewaySlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetPaymentGatewayState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentGatewayList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPaymentGatewayList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.paymentGatewayList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getPaymentGatewayList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Payment Gateway data";
        state.isLoading = false;
      });
  },
});

export const { resetPaymentGatewayState } = paymentGatewaySlice.actions;
export default paymentGatewaySlice.reducer;